import { render, staticRenderFns } from "./FaqModelList.vue?vue&type=template&id=7d5670c4&scoped=true&"
import script from "./FaqModelList.vue?vue&type=script&lang=js&"
export * from "./FaqModelList.vue?vue&type=script&lang=js&"
import style0 from "./FaqModelList.vue?vue&type=style&index=0&id=7d5670c4&prod&lang=css&"
import style1 from "./FaqModelList.vue?vue&type=style&index=1&id=7d5670c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5670c4",
  null
  
)

export default component.exports